import React, { Fragment, useEffect, useState } from "react";
import { useStyles } from "../styles";
import BellNotification from "../notifications/BellNotification";
import {
  CompanyDetails,
  loggedInUserDetails,
} from "../../../recoil/LoggedInUserDetail/selector";
import { useRecoilState, useRecoilValue } from "recoil";
import { get, uniqBy } from "lodash";
import CommunicationNotification from "../communicationNotification/CommunicationNotification";
import VisionNotification from "../visionNotification/VisionNotification";
import {  useMutation, useSubscription } from "@apollo/client";
import { getUserId } from "../../../utils";
import { MenuItem } from "@material-ui/core";
import { userBadgesSubscription } from "../../../graphQL/mutation/giveBadges";
import BadgeRecievedAnimation from "../../modal/AutoAssignBadge/BadgeRecievedAnimation";
import { notificationMessage } from "../../../graphQL/queries/notifications";
import Auth from "@aws-amplify/auth";
import { logOutUser } from "../../../graphQL/mutation/visionBoardMutations";
import { useMainTheme } from "../../../hooks/useMainTheme";
// import { targetCompletionAnimationState } from "Recoil/LoggedInUserDetail/atom";
import { headerNotifi } from "./../../../hooks/Header/headerNotifi";
import {
  bellNotificationDetailSortedState,
  nextTokenState,
  notificationDetailSortedState,
  unReadCountState,
  visionNotificationDetailSortedState,
} from "Recoil/General/atom";

const HeaderNotificationsSection = ({ isMobile = false }) => {
  const [logOutUserDetail] = useMutation(logOutUser);
  const styleProps = useMainTheme();
  const [updatedCount, setUpdatedCount] = useState(false);
  const classes = useStyles(styleProps);
  const companyDetail = useRecoilValue(CompanyDetails);
  const userId = getUserId();
  let _loggedInUserDetails = useRecoilValue(loggedInUserDetails);

  const [modal, setModal] = useState(false);
  // const setShowAnimation = useSetRecoilState(targetCompletionAnimationState);

  const deleteNotification = (
    notificationId,
    setNotificationList,
    notificationList
  ) => {
    const newData = notificationList.filter(
      (res) => get(res, "id", "") !== notificationId
    );
    setNotificationList(newData);
  };
  const isReadNotification = async (
    notificationId,
    setNotificationList,
    notificationList,
    type
  ) => {
    setUnReadCount({ ...unReadCount, [type]: (unReadCount[type] || 1) - 1 });
    const newData = notificationList.map((res) => {
      if (res.id === notificationId) {
        return { ...res, Isread: true };
      } else {
        return res;
      }
    });
    await setNotificationList(newData);
    setUpdatedCount(!updatedCount);
  };

  const {
    // getUserData,
    refetch,
    communicationLoading,
    // getVisionData,
    loadingVision,
    // getGeneralData,
    loadingGeneral,
    nextLazyLoadVision,
    nextLazyLoadCommunication,
    nextLazyLoadGeneral,
    fetchData,
  } = headerNotifi();
  const [badgeDetail, setBadgeDetail] = useState("TeamcaptainCoach");
  const [notificationDetailSorted, setNotificationDetailSorted] =
    useRecoilState(notificationDetailSortedState);
  const [visionNotificationDetailSorted, setVisionNotificationDetailSorted] =
    useRecoilState(visionNotificationDetailSortedState);
  const [bellNotificationDetailSorted, setBellNotificationDetailSorted] =
    useRecoilState(bellNotificationDetailSortedState);
  // const [allNotificationData, setAllNotificationData] = useRecoilState(
  //   allNotificationDataState
  // );
  const [nextToken, setNextToken] = useRecoilState(nextTokenState);
  const [unReadCount, setUnReadCount] = useRecoilState(unReadCountState);

  // const sortingDataForNotification = (data, type) => {
  //   const communicationNotify = [...notificationDetailSorted];
  //   const visionNotify = [...visionNotificationDetailSorted];
  //   const bellNotify = [...bellNotificationDetailSorted];

  //   const allData = concat(
  //     get(data, "listNotifications.items", []),
  //     allNotificationData
  //   );

  //   setAllNotificationData(uniqBy(allData, "id"));

  //   allData.map((res) => {
  //     if (res.isCommunicationNotification) {
  //       communicationNotify.push(res);
  //     } else if (res.isVisionNotification) {
  //       visionNotify.push(res);
  //     } else if (
  //       !res.isCommunicationNotification &&
  //       !res.isVisionNotification
  //     ) {
  //       bellNotify.push(res);
  //     }
  //     return res;
  //   });

  //   setNotificationDetailSorted(
  //     orderBy(uniqBy(communicationNotify, "id"), ["createdAt"], ["desc"])
  //   );
  //   setBellNotificationDetailSorted(
  //     orderBy(uniqBy(bellNotify, "id"), ["createdAt"], ["desc"])
  //   );
  //   setVisionNotificationDetailSorted(
  //     orderBy(uniqBy(visionNotify, "id"), ["createdAt"], ["desc"])
  //   );

  //   setNextToken({
  //     ...nextToken,
  //     [type]: get(data, "listNotifications.nextToken", ""),
  //   });
  //   setUnReadCount({
  //     ...unReadCount,
  //     [type]: get(data, "listNotifications.count", ""),
  //   });

  //   // if (get(data, "listNotifications.nextToken", "")) {
  //   //   const variables = {
  //   //     ...notificationQueryVariables,
  //   //     type,
  //   //     nextToken: get(data, "listNotifications.nextToken", null),
  //   //   };
  //   //   switch (type) {
  //   //     case "General":
  //   //       getGeneralData({ variables });
  //   //       break;
  //   //     case "Communication":
  //   //       getUserData({ variables });
  //   //       break;
  //   //     case "Vision":
  //   //       getVisionData({ variables });
  //   //       break;
  //   //     default:
  //   //       break;
  //   //   }
  //   // }
  // };
  // const fetchData = () => {
  //   getGeneralData({
  //     variables: {
  //       ...notificationQueryVariables,
  //       type: "General",
  //     },
  //   });
  //   getUserData({
  //     variables: {
  //       ...notificationQueryVariables,
  //       type: "Communication",
  //     },
  //   });
  //   getVisionData({
  //     variables: {
  //       ...notificationQueryVariables,
  //       type: "Vision",
  //     },
  //   });
  // };
  // const [getUserData, { refetch, loading: communicationLoading }] =
  //   useLazyQuery(getUserCommunicationNotification, {
  //     ssr: false,
  //     fetchPolicy: FETCH_POLICY.networkOnly,
  //     nextFetchPolicy: FETCH_POLICY.cacheOnly,
  //     onCompleted: (data) => {
  //       sortingDataForNotification(data, "Communication");
  //     },
  //   });

  // const [getVisionData, { loading: loadingVision }] = useLazyQuery(
  //   getUserVisionNotification,
  //   {
  //     ssr: false,
  //     fetchPolicy: FETCH_POLICY.networkOnly,
  //     nextFetchPolicy: FETCH_POLICY.cacheOnly,
  //     onCompleted: (data) => {
  //       sortingDataForNotification(data, "Vision");
  //     },
  //   }
  // );

  // const [getGeneralData, { loading: loadingGeneral }] = useLazyQuery(
  //   getUserGeneralNotification,
  //   {
  //     ssr: false,
  //     fetchPolicy: FETCH_POLICY.networkOnly,
  //     nextFetchPolicy: FETCH_POLICY.cacheOnly,
  //     onCompleted: (data) => {
  //       sortingDataForNotification(data, "General");
  //     },
  //   }
  // );
  // const userId = getUserId()
  useEffect(() => {
    if (userId) fetchData();
  }, [userId]);

  useSubscription(userBadgesSubscription, {
    variables: { userId },
    onSubscriptionData: (result) => {
      const userBadge = get(
        result,
        "subscriptionData.data.onUserBadgesMutation",
        ""
      );
      setBadgeDetail(get(userBadge, "badge", ""));
      setModal(true);
    },
  });
  // Notification subscription
  useSubscription(notificationMessage, {
    variables: { userId },
    onSubscriptionData: async (result) => {
      const message = get(
        result,
        "subscriptionData.data.onNotificationMutation",
        ""
      );

      if (message) {
        if (
          message.notificationType === "UserDeactivation" &&
          message.message.objectId === userId
        ) {
          const variableDetails = {
            companyId: message.companyId,
            userId,
          };
          logOutUserDetail({ variables: variableDetails }).then(() => {
            Auth.signOut().then(() => {
              localStorage.removeItem("tenantId");
              window.location.href = "/";
            });
          });
        }
        if (message.isCommunicationNotification) {
          setNotificationDetailSorted(
            uniqBy([message, ...notificationDetailSorted], "id")
          );
          const findData = notificationDetailSorted?.findIndex(
            (res) => res?.id === message?.id
          );
          findData >= 0 &&
            setUnReadCount({
              ...unReadCount,
              ["Communication"]: (unReadCount["Communication"] || 0) + 1,
            });
        } else if (message.isVisionNotification) {
          setVisionNotificationDetailSorted(
            uniqBy([message, ...visionNotificationDetailSorted], "id")
          );
          const findData = visionNotificationDetailSorted?.findIndex(
            (res) => res?.id === message?.id
          );
          findData >= 0 &&
            setUnReadCount({
              ...unReadCount,
              ["Vision"]: (unReadCount["Vision"] || 0) + 1,
            });
        } else if (
          !message.isCommunicationNotification &&
          !message.isVisionNotification
        ) {
          const findData = bellNotificationDetailSorted?.findIndex(
            (res) => res?.id === message?.id
          );
          findData >= 0 &&
            setUnReadCount({
              ...unReadCount,
              ["General"]: (unReadCount["General"] || 0) + 1,
            });
          // if target completed show confetti
          // UserTargetMarkedCompletedByCreator, UserTargetSelfCompletion, TargetCompletionRequestApproved
          // if (
          //   [
          //     "UserTargetMarkedCompletedByCreator",
          //     "UserTargetSelfCompletion",
          //     "TargetCompletionRequestApproved",
          //     "TargetCompleted"
          //   ].includes(get(message, "notificationType", "")) &&
          //   !get(message, "message.title", "").includes("Incomplete")
          // ) {
          //   setShowAnimation(true);
          // }

          // Check if notification is completed or incompleted and show confetti
          setBellNotificationDetailSorted(
            uniqBy([message, ...bellNotificationDetailSorted], "id")
          );
        }
      }
    },
  });
  // const nextLazyLoadVision = () => {
  //   if (nextToken["Vision"]) {
  //     setNextToken({ ...nextToken, ["Vision"]: null });
  //     getVisionData({
  //       variables: {
  //         ...notificationQueryVariables,
  //         nextToken: nextToken["Vision"],
  //         type: "Vision",
  //       },
  //     });
  //   }
  // };

  // const nextLazyLoadCommunication = () => {
  //   if (!communicationLoading && nextToken["Communication"]) {
  //     setNextToken({ ...nextToken, ["Communication"]: null });
  //     getUserData({
  //       variables: {
  //         ...notificationQueryVariables,
  //         nextToken: nextToken["Communication"],
  //         type: "Communication",
  //       },
  //     });
  //   }
  // };

  // const nextLazyLoadGeneral = () => {
  //   if (nextToken["General"]) {
  //     setNextToken({ ...nextToken, ["General"]: null });

  //     getGeneralData({
  //       variables: {
  //         ...notificationQueryVariables,
  //         nextToken: nextToken["General"],
  //         type: "General",
  //       },
  //     });
  //   }
  // };
  return (
    <Fragment>
      {!isMobile ? (
        <div className={classes.headerMenu}>
          <div className={classes.divider}>
            <VisionNotification
              nextLazyLoad={nextLazyLoadVision}
              nextToken={nextToken["Vision"]}
              loading={loadingVision}
              updatedCount={updatedCount}
              unReadCount={unReadCount["Vision"]}
              setUnReadCount={setUnReadCount}
              refetchUserData={deleteNotification}
              isReadNotification={isReadNotification}
              notificationDetailSorted={visionNotificationDetailSorted}
              setNotificationDetailSorted={setVisionNotificationDetailSorted}
            />

            {get(companyDetail, "feature.communication", false) ? (
              <CommunicationNotification
                nextLazyLoad={nextLazyLoadCommunication}
                nextToken={nextToken["Communication"]}
                unReadCount={unReadCount["Communication"]}
                setUnReadCount={setUnReadCount}
                loading={communicationLoading}
                refetchUserData={deleteNotification}
                isReadNotification={isReadNotification}
                updatedCount={updatedCount}
                notificationDetailSorted={notificationDetailSorted}
                setNotificationDetailSorted={setNotificationDetailSorted}
              />
            ) : null}
            <BellNotification
              nextLazyLoad={nextLazyLoadGeneral}
              nextToken={nextToken["General"]}
              loading={loadingGeneral}
              unReadCount={unReadCount["General"]}
              setUnReadCount={setUnReadCount}
              refetchUserData={deleteNotification}
              isReadNotification={isReadNotification}
              updatedCount={updatedCount}
              notificationDetailSorted={bellNotificationDetailSorted}
              setNotificationDetailSorted={setBellNotificationDetailSorted}
            />
          </div>
        </div>
      ) : (
        <Fragment>
          <MenuItem>
            <VisionNotification
              nextLazyLoad={nextLazyLoadVision}
              nextToken={nextToken["Vision"]}
              loading={loadingVision}
              updatedCount={updatedCount}
              unReadCount={unReadCount["Vision"]}
              refetchUserData={deleteNotification}
              isReadNotification={isReadNotification}
              notificationDetailSorted={visionNotificationDetailSorted}
              setNotificationDetailSorted={setVisionNotificationDetailSorted}
              isMobile={isMobile}
            />
          </MenuItem>
          {get(companyDetail, "feature.communication", false) ? (
            <MenuItem>
              <CommunicationNotification
                nextLazyLoad={nextLazyLoadCommunication}
                nextToken={nextToken["Communication"]}
                unReadCount={unReadCount["Communication"]}
                loading={communicationLoading}
                refetchUserData={deleteNotification}
                isReadNotification={isReadNotification}
                updatedCount={updatedCount}
                notificationDetailSorted={notificationDetailSorted}
                setNotificationDetailSorted={setNotificationDetailSorted}
                isMobile={isMobile}
              />
            </MenuItem>
          ) : null}
          <MenuItem>
            <BellNotification
              nextLazyLoad={nextLazyLoadGeneral}
              nextToken={nextToken["General"]}
              loading={loadingGeneral}
              unReadCount={unReadCount["General"]}
              refetchUserData={deleteNotification}
              isReadNotification={isReadNotification}
              updatedCount={updatedCount}
              notificationDetailSorted={bellNotificationDetailSorted}
              setNotificationDetailSorted={setBellNotificationDetailSorted}
              isMobile={isMobile}
            />
          </MenuItem>
        </Fragment>
      )}

      {modal && (
        <BadgeRecievedAnimation
          badgeDetail={badgeDetail}
          open={modal}
          setOpen={setModal}
          onSubmit={""}
        />
      )}
    </Fragment>
  );
};

export default HeaderNotificationsSection;
